<template>
  <v-dialog persistent v-model="showDeleteMessageModal" width="500">
    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        Delete Message
      </v-card-title>

      <v-card-text>
        Are you sure you want to delete this message? This can't be undone
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="secondary" text @click.stop="closedialog()">
          Cancel
        </v-btn>
        <v-btn color="primary" text @click.prevent="submit()">
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    message: Object,
    currentlySelectedAccount: String,
    showDeleteMessageModal: Boolean,
    messageForDeletion: Object
  },

  methods: {
    async submit() {
      const data = {
        acct_name: this.currentlySelectedAccount,
        msg_id: this.messageForDeletion._id
      };
      console.log(data);

      const res = await this.$store.dispatch("deleteSingleMessage", data);
      if (res.Error) {
        this.$store.dispatch("addNotification", {
          type: "errorMessage",
          message: `${res.Error}`
        });
      } else {
        this.$store.dispatch("addNotification", {
          type: "success",
          message: `message has been deleted`
        });
        this.$emit("refreshconversations");
      }

      this.$emit("closeDeleteMessageModal");
    },
    closedialog() {
      this.$emit("closeDeleteMessageModal");
    },
    handle() {
      console.log("nothing");
    }
  }
};
</script>

<style></style>
